<bxi-current-state-panel [title]="'gridBattery.title'" [data]="data()"></bxi-current-state-panel>
